module.exports = __webpack_public_path__ + "static/media/gtvimg.7c2116fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gtvimg.jpg
// module id = 1098
// module chunks = 114